import React, { useState } from 'react';
import { Player } from 'react-tuby';
import 'react-tuby/css/main.css';
import Trans from '../assets/5th KIPPRA Annual Regional Conference - English.srt';
import Vid from '../assets/6th KARC.mp4';
import Vid2 from '../assets/KIP1.mp4';
import Vid3 from '../assets/KIP2.mp4';
import Vid4 from '../assets/KIP3.mp4';
import Vid5 from '../assets/KIP4.mp4';
import Vid6 from '../assets/kippra.mp4';
import POS6 from '../assets/POS6.png';
import POS5 from '../assets/POS5.png';
import POS4 from '../assets/POS4.png';
import POS3 from '../assets/POS3.png';
import POS2 from '../assets/POS2.png';
import POS1 from '../assets/POS1.png';
import PlayButtonIcon from '../assets/You.svg.png'; // Replace with your play button icon
import './Vid1.css';

const videos = [
  {
    quality: 'Full HD',
    url: Vid,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS1,
  },
  {
    quality: 'Full HD',
    url: Vid2,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS2,
  },
  {
    quality: 'Full HD',
    url: Vid3,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS3,
  },
  {
    quality: 'Full HD',
    url: Vid4,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS4,
  },
  {
    quality: 'Full HD',
    url: Vid5,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS5,
  },
  {
    quality: 'Full HD',
    url: Vid6,
    subtitleLang: 'en',
    subtitleUrl: Trans,
    poster: POS6,
  },
  // Add more video sources here
];

const Vid1 = () => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);

  const playVideo = (index) => {
    setPlayingVideoIndex(index);
  };

  return (
    <div className="vid1 w-full max-w-screen-lg mx-auto">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-2">
        {videos.map((video, index) => (
          <div key={index} className="mb-4">
            <div
              onClick={() => playVideo(index)}
              style={{
                cursor: 'pointer',
                position: 'relative',
              }}
            >
              {playingVideoIndex === index ? (
                <Player
                  src={[
                    {
                      quality: video.quality,
                      url: video.url,
                    },
                    {
                      quality: 720,
                      url: video.url,
                    },
                    {
                      quality: 480,
                      url: video.url,
                    },
                  ]}
                  subtitles={[
                    {
                      lang: video.subtitleLang,
                      language: 'English',
                      url: video.subtitleUrl,
                    },
                    {
                      lang: 'fr',
                      language: 'French',
                      url: video.subtitleUrl,
                    },
                  ]}
                  poster={video.poster}
                  className="w-full h-auto md:w-full xl:w-full xxl:w-full"
                >
                  {(ref, props) => <Vidj videoRef={ref} videoProps={props} />}
                </Player>
              ) : (
                <div className="relative">
                  <img
                    src={video.poster}
                    alt="Thumbnail"
                    className="w-full"
                  />
                  <div className="play-button-overlay">
                    <img
                      src={PlayButtonIcon}
                      alt="Play Button"
                      style={{ width: '30px', height: '30px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Vidj = ({ videoRef, videoProps }) => {
  return (
    <div className="w-full">
      <video ref={videoRef} {...videoProps} className="w-full h-auto" />
    </div>
  );
};

export default Vid1;
